import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import Select from "react-select";

import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import NumberFormat from "react-number-format";
import apiform from "utils/APIForm";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    position: "absolute",
    width: "60%",
    height: "80%",

    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  table: {
    minWidth: 650
  },
}));

const ModalTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root}
      {...other}
      style={{ textAlign: "center" }}
    >
      <Typography variant="h6" style={{ textTransform: "none" }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator={true}
      decimalSeparator={false}
      allowNegative={false}
      isNumericString
      prefix="$ "
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

const ModalAddPatient = props => {
  const classes = useStyles();
  const {
    openModal,
    closeModal,
    patients,
    setPatients,
    idFicha,
    setMessage,
    vetoesInfo,
    setVetoesInfo,
    setOpenDialog,
    setPageRefresh,
    variableCounter,
    setVariableCounter
  } = props;
  const [openAnimation, setOpenAnimation] = useState(false);
  const [patient, setPatient] = useState({});
  const [motivo, setMotivo] = useState("");

  const handlePatient = patient => {
    setPatient(patient);
  };

  const addVeto = () => {
    setOpenAnimation(true);
    let tempVariableCounter = { ...variableCounter };
    let tempPatients = patients.filter(
      filtered => JSON.stringify(filtered) != JSON.stringify(patient)
    );
    let tempVetoes = vetoesInfo;
    const formData = new FormData();
    formData.append(
      "fecha_hora_inicio",
      moment().format("YYYY-MM-DDTHH:mm:ss")
    );
    formData.append("id_ficha_paciente", patient.value);
    formData.append("id_ficha_personal", idFicha);
    formData.append("motivo", motivo);

    apiform
      .post("api/rrhh/variablesdinamicas/registros/vetos/", formData)
      .then(response => {
        tempVariableCounter.cantidad_vetos = variableCounter.cantidad_vetos + 1;
        setVariableCounter(tempVariableCounter);
        tempVetoes.push(response.data);
        setVetoesInfo(tempVetoes);
        setPatients(tempPatients);
        setMessage("Registro guardado con éxito");
        setOpenAnimation(false);
        setPageRefresh(true);
        setOpenDialog(true);
      })

  };

  return (
    <Modal
      open={openModal}
      onClose={closeModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableBackdropClick
    >
      <Paper
        className={classes.paper}
        style={{ maxHeight: "580px", overflow: "auto" }}
      >
        {openAnimation ? (
          <ModalTitle id="customized-dialog-title">Agregar registro</ModalTitle>
        ) : (
          <ModalTitle id="customized-dialog-title" onClose={closeModal}>
            Agregar registro
          </ModalTitle>
        )}
        <DialogContent>
          <Grid container className={classes.root} justify="center">
            <Grid item container xs={12} justify="center">
              <Grid
                item
                container
                xs={7}
                justify="center"
                style={{ marginBottom: "1em" }}
              >
                <Grid item xs={7}>
                  <label className="text-dark">Paciente</label>
                  <Select
                    value={Object.keys(patient).length > 0 ? patient : " "}
                    onChange={handlePatient}
                    options={patients}
                    placeholder={
                      Object.keys(patient).length > 0 ? (
                        "Seleccione"
                      ) : (
                        <span className="text-danger">Requerido</span>
                      )
                    }
                    styles={{
                      // Fixes the overlapping problem of the component
                      menu: provided => ({ ...provided, zIndex: 9999 })
                    }}
                    noOptionsMessage={() => "Sin resultados"}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                container
                xs={7}
                justify="center"
                style={{ marginTop: "3em", marginBottom: "3em" }}
              >
                <Grid item xs={7}>
                  <TextField
                    error={motivo === "" ? true : false}
                    fullWidth
                    id="outlined-multiline-static"
                    label="Motivo"
                    multiline
                    rows={5}
                    variant="outlined"
                    value={motivo}
                    onChange={e => setMotivo(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", marginTop: "2em" }}>
          {openAnimation ? (
            <CircularProgress />
          ) : (
            <div>
              {Object.keys(patient).length > 0 && motivo != "" ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addVeto}
                  style={{ textTransform: "none", marginLeft: "3px" }}
                >
                  Agregar
                </Button>
              ) : (
                <Button
                  disabled
                  variant="contained"
                  color="primary"
                  onClick={addVeto}
                  style={{ textTransform: "none", marginLeft: "3px" }}
                >
                  Agregar
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={closeModal}
                style={{ textTransform: "none", marginLeft: "3px" }}
              >
                Cerrar
              </Button>
            </div>
          )}
        </DialogActions>
      </Paper>
    </Modal>
  );
};

export default ModalAddPatient;

ModalAddPatient.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
  patients: PropTypes.array,
  idFicha: PropTypes.string,
  setMessage: PropTypes.func,
  vetoesInfo: PropTypes.array,
  setVetoesInfo: PropTypes.func,
  setOpenDialog: PropTypes.func,
  setPageRefresh: PropTypes.func,
  setPatients: PropTypes.func,
  variableCounter: PropTypes.object,
  setVariableCounter: PropTypes.func
};
